module.exports = __webpack_public_path__ + "static/media/image_case_yuedinghui.af7f0b50.png";